export default __webpack_public_path__ + "static/media/consorcioLogo.4c06f957.svg";